import { useCallback, useTransition } from 'react';

interface UseIconCategoryTransitionResult {
  isPending: boolean;
  selectCategory: (category: string, callback: () => void) => void;
}

export function useIconCategoryTransition(): UseIconCategoryTransitionResult {
  const [isPending, startTransition] = useTransition();

  const selectCategory = useCallback(
    (_category: string, callback: () => void) => {
      startTransition(() => {
        callback();
      });
    },
    []
  );

  return { isPending, selectCategory };
}
